import { css } from 'styled-components';
import { themeGet } from '../theme/themeGet/get.js';
import { pxToRem } from '../spacing/utils.js';

var SCROLLBAR_SIZE = 6;
var SCROLLBAR_BORDER_RADIUS = themeGet('borderRadius.md');
var SCROLLBAR_TRACK_BACKGROUND = 'gray.50';
var SCROLLBAR_THUMB_COLOR = 'gray.200';
var SCROLLBAR_THUMB_COLOR_HOVER = 'gray.300';
var scrollbar = function scrollbar(options) {
  var _ref = options || {},
    trackMargin = _ref.trackMargin,
    _ref$trackBackground = _ref.trackBackground,
    trackBackground = _ref$trackBackground === void 0 ? SCROLLBAR_TRACK_BACKGROUND : _ref$trackBackground,
    _ref$trackSize = _ref.trackSize,
    trackSize = _ref$trackSize === void 0 ? SCROLLBAR_SIZE : _ref$trackSize,
    _ref$thumbColor = _ref.thumbColor,
    thumbColor = _ref$thumbColor === void 0 ? SCROLLBAR_THUMB_COLOR : _ref$thumbColor,
    _ref$thumbColorHover = _ref.thumbColorHover,
    thumbColorHover = _ref$thumbColorHover === void 0 ? SCROLLBAR_THUMB_COLOR_HOVER : _ref$thumbColorHover;
  var trackSizeRem = pxToRem(trackSize);
  return css(["&::-webkit-scrollbar{width:", ";height:", ";}&::-webkit-scrollbar-track{margin-top:", ";margin-bottom:", ";border-radius:", ";}&::-webkit-scrollbar-thumb{width:", ";height:", ";border-radius:", ";}&:hover{&::-webkit-scrollbar-track{background:", ";}&::-webkit-scrollbar-thumb{background:", ";&:hover{background:", ";}}}"], trackSizeRem, trackSizeRem, trackMargin && themeGet("spacing." + trackMargin), trackMargin && themeGet("spacing." + trackMargin), SCROLLBAR_BORDER_RADIUS, trackSizeRem, trackSizeRem, SCROLLBAR_BORDER_RADIUS, themeGet("colors." + trackBackground), themeGet("colors." + thumbColor), themeGet("colors." + thumbColorHover));
};

export { scrollbar };
